import { call, put, takeEvery } from 'redux-saga/effects'
import get_ from 'lodash/get'
import { generalDoFailure } from '../../../util/fetchFailure'
import { privateFetch } from '../../../fetch'
import { API_URL_PATH_KEG_COLLECTION_BOOKING } from '../../../../../constants'
import { FETCH_SINGLE_KEG_COLLECTION_BOOKING } from '../../../../actions/actionTypes'

import {
  fetchSingleKegCollectionBookingRequest,
  fetchSingleKegCollectionBookingSuccess,
  fetchSingleKegCollectionBookingFailure,
  saveSingleKegCollectionBooking,
} from './utils'

function* fetchSingleBookingWorker(action) {
  if (!action) return

  const { bookingId } = action.payload || {}

  yield put(fetchSingleKegCollectionBookingRequest())

  let response
  try {
    response = yield call(privateFetch, {
      path: API_URL_PATH_KEG_COLLECTION_BOOKING(bookingId),
    })
    const singleBooking = response.data

    yield call(doSuccess, singleBooking)
  } catch (error) {
    if (get_(error, 'response.status') === 404) {
      yield call(doSuccess, null)
      return
    }
    yield call(doFailure, error)
  }
}

export default [[takeEvery, FETCH_SINGLE_KEG_COLLECTION_BOOKING, fetchSingleBookingWorker]]

function* doSuccess(booking) {
  yield put(saveSingleKegCollectionBooking(booking))
  yield put(fetchSingleKegCollectionBookingSuccess())
}

function* doFailure(error) {
  yield call(generalDoFailure, {
    error,
    action: fetchSingleKegCollectionBookingFailure(error),
  })
}
